module.exports = __webpack_public_path__ + "static/vf_mpants3_core.f409b0f2.svg";